import { dashboardModuleName, votingPageModuleName } from './findtimeBootstrap.locstring.json';
import loc from 'owa-localize';
import { parseURL } from './utils/routeUtils';
import { FindTimeMainModule, FindTimeEntryPoint, FindTimeUrlData } from 'findtime-main-module';
import { bootstrap as appBootstrap } from 'owa-bootstrap';
import { SessionData } from 'owa-service/lib/types/SessionData';
import { OwaWorkload } from 'owa-workloads';
import * as React from 'react';
import { initializeIcons } from '@fluentui/react/lib/Icons';
import { runAfterVotingPageBootstrap, runAfterDashboardBootstrap } from './utils/runAfterBootstrap';
import { setupErrorHandler } from 'owa-exception-handler-devtools';
import { isAnonymousUser } from 'owa-config/lib/anonymousUtils';

// Order is important, do not mess with it :)
export default function bootstrap(sessionPromise: Promise<SessionData>) {
    let urlData: FindTimeUrlData = parseURL();
    return appBootstrap({
        initializeState: () => {
            initializeIcons();
            switch (urlData.entryPoint) {
                case FindTimeEntryPoint.VotingPage:
                    runAfterVotingPageBootstrap(urlData.getRequestUrl, urlData.unsubscribe);
                    break;
                case FindTimeEntryPoint.Dashboard:
                    runAfterDashboardBootstrap();
                    break;
                default:
                    break;
            }
        },
        analyticsOptions: {
            ariaTenantTokens: [
                '199fda8f7c2e423291001798b2f173c5-fcb15ea6-c8e1-430e-bfed-450cc70fcd67-6876',
            ],
        },
        renderMainComponent: () => (
            <FindTimeMainModule
                entryPoint={urlData.entryPoint}
                getRequestUrl={urlData.getRequestUrl}
            />
        ),
        sessionPromise,
        getModuleName: () =>
            urlData.entryPoint == FindTimeEntryPoint.Dashboard
                ? loc(dashboardModuleName)
                : loc(votingPageModuleName),
        workload: OwaWorkload.FindTime,
        shouldInitializeTimeZoneAnonymously: isAnonymousUser(),
    }).then(() => {
        setupErrorHandler();
    });
}
